import { SalaryMasterLog } from "../../types/SalaryMasterLog";
import {
  SalaryMasterLogActions,
  SalaryActionLogList,
} from "../actions/salaryMasterLogAction";

const initialState: SalaryMasterLog[] = [];

export const salaryMasterLogReducer = (
  state: SalaryMasterLog[] = initialState,
  action: SalaryMasterLogActions,
): SalaryMasterLog[] => {
  switch (action.type) {
    case SalaryActionLogList.ADD_SALARYLog:
      return [...state, action.data];

    case SalaryActionLogList.EDIT_SALARYLog:
      return state.map((s) =>
        s.id === action.data.id ? { ...action.data } : s,
      );

    case SalaryActionLogList.FETCH_SALARIESLog:
      return action.data;

    case SalaryActionLogList.DELETE_SALARYLog:
      return state.filter((s) => s.id !== action.data);

    default:
      return state;
  }
};
